import isWithinRange from 'date-fns/is_within_range'
import isAfter from 'date-fns/is_after'
import addDays from 'date-fns/add_days'

export const MAX_DATE = new Date(9999, 11, 31, 23, 59, 59, 999999)

export const MIN_DATE = new Date(1, 0, 1)

export function currentlyBetweenDates(start, end, inclusive=false) {
  try {
    let startDate, endDate

    if (start) {
      startDate = new Date(start)
    }else {
      return false
    }
    if (end) {
      endDate = new Date(end)
      if (inclusive) {
        endDate = addDays(endDate, 1)
      }
    } else {
      return false
    }
    const now = new Date()

    return isWithinRange(now,startDate,endDate)
  } catch (e) {
    return false
  }
}
export function currentlyAfter(start){
  try{
    let startDate
    if(start){
      startDate = new Date(start)
    }else{
      return false
    }
    const now = new Date()
    if(startDate.getFullYear() == MIN_DATE.getFullYear()) return false

    return isAfter(now, startDate)

  }catch (e) {
    return false
  }
}



// WEBPACK FOOTER //
// ./ixcms/themes/src/vue-src/utils/dates.js